import { Provisao77p } from './../../../../../types/Provisao77p.type';
import { Component, OnInit } from '@angular/core';
import { Empresa } from '../../../../../types/Empresa.type';
import { IntegradorService } from '../../../../../services/integrador.service';
import { ToastService } from '../../../../../services/toast.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-provisao77pform',
  templateUrl: './provisao77pform.component.html',
  styleUrl: './provisao77pform.component.css'
})
export class Provisao77pFormComponent implements OnInit {

  provisao77p: Provisao77p = {} as Provisao77p
  provisao77pCadastro: Provisao77p = {} as Provisao77p;
  empresas: Empresa[] = [];

  constructor(private integradorService: IntegradorService, private toastService: ToastService, private activatedRoute: ActivatedRoute, private location: Location){}

  ngOnInit(){
    this.buscaProvisao()
    this.buscaEmpresas();
  }

  buscaProvisao(){
    let id = this.activatedRoute.snapshot.paramMap.get('id');

    if(id){
      this.integradorService.getProvisao77p(id).subscribe({
        next: (data) => {
          this.provisao77p = data
        },
        error: (error) => {
          console.error(error)
          this.toastService.erro("Erro", error.error.message)
        }
      })
    }
  }

  buscaEmpresas(){
    this.integradorService.getEmpresas().subscribe({
      next: (data) => {
        this.empresas = data
      },
      error: (error) => {
        console.error(error)
        this.toastService.erro("Erro", error.error.message)
      }
    })
  }

  salvar() {
    Object.assign(this.provisao77pCadastro, this.provisao77p);

    let empresaSelecionada = this.buscaEmpresaSelecionada(this.provisao77pCadastro.empresaErp);

    if(empresaSelecionada != undefined){
      this.provisao77pCadastro.idEmpresa = empresaSelecionada.id;
    }

    this.provisao77pCadastro.tipoPropriedade = this.provisao77pCadastro.tipoPropriedade?.trim() != '' ? this.provisao77pCadastro.tipoPropriedade : null;
    this.provisao77pCadastro.ordem = this.provisao77pCadastro.ordem?.trim() != '' ? this.provisao77pCadastro.ordem : null;
    this.provisao77pCadastro.contaCredito = this.provisao77pCadastro.contaCredito?.trim() != '' ? this.provisao77pCadastro.contaCredito : null;
    this.provisao77pCadastro.contaDebito = this.provisao77pCadastro.contaDebito?.trim() != '' ? this.provisao77pCadastro.contaDebito : null;
    this.provisao77pCadastro.centroCusto = this.provisao77pCadastro.centroCusto?.trim() != '' ? this.provisao77pCadastro.centroCusto : null;

    if (this.provisao77p.id) {

      this.integradorService.putProvisao77p(this.provisao77pCadastro).subscribe({
        next: () => {
          this.toastService.sucesso('Sucesso', 'Provisão atualizada com sucesso');
          this.fecharDialog();
        },
        error: (value) => {
          this.toastService.erro('Erro', 'Erro ao salvar: ' + value.error.message);
        },
      });
    } else {

      this.integradorService.postProvisao77p(this.provisao77pCadastro).subscribe({
        next: (valor) => {
          Object.assign(this.provisao77p, valor);
          this.toastService.sucesso('Sucesso', 'Provisão salva com sucesso');
          this.fecharDialog();
        },
        error: (value) => {
          this.toastService.erro('Erro', 'Erro ao salvar: ' + value.error.message);
        },
      });
    }
  }

  buscaEmpresaSelecionada = (empresaErp: string): Empresa | undefined => {
    return this.empresas.find(empresa => empresa.empresaErp === empresaErp);
  };

  fecharDialog() {
    this.provisao77p = {} as Provisao77p;
    this.location.back();
  }
}
